import { createContext } from 'react';

export interface ProgressStepContextValue {
	/** When non-null, ProgressIndicator uses this step instead of URL-based detection. */
	stepOverride: number | null;
	setStepOverride: (step: number | null) => void;
}

export const ProgressStepContext = createContext<ProgressStepContextValue>({
	stepOverride: null,
	setStepOverride: () => {}
});
